module.exports = __webpack_public_path__ + "media/packs/faq/images/share-a7098a772ecb256d1caaa1a596d7bb0f.svg";